export enum UnloadTypeMixVeyorCodes {
  MIXVEYOR = 'MIXVEYOR', // TAPIS FOR FRANCE
}
